import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';

const HowItWorksSelector = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-2xl mx-auto text-center">
          {/* Badge */}
          <div className="flex justify-center mb-8">
            <div
              className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 border border-white/20"
              style={{ background: 'linear-gradient(to right, #F58A54, #F06F6B, #E0528A)' }}
            >
              <Icon name="HelpCircle" size={14} color="white" />
              <span className="text-white text-sm font-medium tracking-wide">How It Works</span>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4 leading-tight">
            Are you a vendor?
          </h1>
          <p className="text-text-secondary text-lg max-w-md mx-auto mb-12">
            We'll show you the experience that's most relevant to you.
          </p>

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* Yes — Vendor */}
            <button
              onClick={() => navigate('/vendor-how-it-works')}
              className="group relative overflow-hidden rounded-2xl border border-border bg-card p-8 text-left hover:border-primary/40 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{ background: 'linear-gradient(135deg, rgba(245,138,84,0.06) 0%, rgba(224,82,138,0.06) 100%)' }}
              />
              <div className="relative">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                  style={{ background: 'linear-gradient(135deg, #F58A54, #F06F6B)' }}
                >
                  <Icon name="Briefcase" size={26} color="white" />
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xl font-bold text-foreground">Yes, I'm a vendor</span>
                </div>
                <p className="text-text-secondary text-sm leading-relaxed mb-5">
                  Learn how to receive quote requests, submit bids, get selected, and grow your business on Stackd.
                </p>
                <div className="flex items-center gap-1.5 font-semibold text-sm" style={{ color: '#F06F6B' }}>
                  <span>See vendor guide</span>
                  <Icon name="ArrowRight" size={15} color="#F06F6B" className="group-hover:translate-x-1 transition-transform duration-200" />
                </div>
              </div>
            </button>

            {/* No — Buyer */}
            <button
              onClick={() => navigate('/how-it-works')}
              className="group relative overflow-hidden rounded-2xl border border-border bg-card p-8 text-left hover:border-primary/40 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{ background: 'linear-gradient(135deg, rgba(245,138,84,0.06) 0%, rgba(224,82,138,0.06) 100%)' }}
              />
              <div className="relative">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5"
                  style={{ background: 'linear-gradient(135deg, #F06F6B, #E0528A)' }}
                >
                  <Icon name="ShoppingBag" size={26} color="white" />
                </div>
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xl font-bold text-foreground">No, I'm a buyer</span>
                </div>
                <p className="text-text-secondary text-sm leading-relaxed mb-5">
                  Discover how to create a Stack, connect with vendors, compare quotes, and make confident purchasing decisions.
                </p>
                <div className="flex items-center gap-1.5 font-semibold text-sm" style={{ color: '#F06F6B' }}>
                  <span>See buyer guide</span>
                  <Icon name="ArrowRight" size={15} color="#F06F6B" className="group-hover:translate-x-1 transition-transform duration-200" />
                </div>
              </div>
            </button>
          </div>

          {/* Subtle divider hint */}
          <p className="text-text-secondary text-sm mt-10 opacity-60">
            You can always switch between guides from the navigation.
          </p>
        </div>
      </main>
    </div>
  );
};

export default HowItWorksSelector;
